import { render, staticRenderFns } from "./videoPlayNoAd.vue?vue&type=template&id=21fda1a1&scoped=true"
import script from "./videoPlayNoAd.vue?vue&type=script&lang=js"
export * from "./videoPlayNoAd.vue?vue&type=script&lang=js"
import style0 from "./videoPlayNoAd.vue?vue&type=style&index=0&id=21fda1a1&prod&lang=less&scoped=true"
import style1 from "./videoPlayNoAd.vue?vue&type=style&index=1&id=21fda1a1&prod&lang=less"
import style2 from "./videoPlayNoAd.vue?vue&type=style&index=2&id=21fda1a1&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21fda1a1",
  null
  
)

export default component.exports